// src/auth/AdminRoute.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { RedirectToSignIn } from '@clerk/clerk-react';
import { useAuth } from '../context/AuthContext';
import { useAdminGate } from '../hooks/useAdminGate';

export default function AdminRoute({ children }) {
  const { user, authReady } = useAuth();
  const { loading, isAdmin } = useAdminGate();

  // Loading state - show while checking auth or admin status
  if (!authReady || loading) {
    return (
      <div className="min-h-[60vh] grid place-items-center bg-[#0b0b12] text-white">
        <div className="opacity-80">Loading…</div>
      </div>
    );
  }

  // Not authenticated - redirect to sign in
  if (!user) {
    return <RedirectToSignIn />;
  }

  // Not admin - show access denied
  if (!isAdmin) {
    return (
      <div className="min-h-[60vh] grid place-items-center bg-[#0b0b12] text-white">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4">🚫 Access Denied</h1>
          <p className="text-lg opacity-80 mb-6">
            You don't have permission to access this page.
          </p>
          <Link 
            to="/" 
            className="inline-block px-6 py-3 bg-fuchsia-600 hover:bg-fuchsia-700 rounded-lg font-semibold transition"
          >
            Return to Home
          </Link>
        </div>
      </div>
    );
  }

  // Authorized - render children
  return children;
}
